import script from "./ApiTokensLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiTokensLoader.vue?vue&type=script&setup=true&lang=js"

import "./ApiTokensLoader.vue?vue&type=style&index=0&id=2b5ea4f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5ea4f4"]])

export default __exports__